import { crossBackLace, mixBackLace, straightBackLace } from 'src/features/brands/gorilla/canvas/glove/rightThrow/back/lace/backLace'
import { Brand, Position, State } from 'src/types'
import {
  crossBackLace as crossBackLaceOfFront,
  straightBackLace as straightBackLaceOfFront
} from 'src/features/brands/gorilla/canvas/glove/rightThrow/front/lace/backLace'
import { outfielderDefaultBackLace } from 'src/features/brands/gorilla/canvas/glove/rightThrow/back/lace/outfielderDefaultBackLace'
import { outfielderDefaultBackLaceForFront } from 'src/features/brands/gorilla/canvas/glove/rightThrow/front/lace/outfielderDefaultBackLace'
import {
  gorillaEngravedOfBackBand,
  gorillaEngravedOfBackPinkey,
  gorillaEngravedOfBackPinkeyLeftThrow,
  gorillaEngravedOfBackThumb,
  gorillaEngravedOfBackThumbLeftThrow,
  gorillaEngravedOfCatchFace,
  gorillaLabelHead,
  gorillaLabelOverAll,
  gorillaLabelOverAllWithBanana
} from 'src/features/brands/gorilla/canvas/labels/gorilla'

export const backLaceDrawerOfFront = (ctx: CanvasRenderingContext2D, backLaceValue: string, laceColor: string, position: Position): void => {
  switch (backLaceValue) {
    case 'straight':
      straightBackLaceOfFront(ctx, laceColor, 0, 0, 1)
      straightBackLaceOfFront(ctx, laceColor, 128, -270, 30)
      straightBackLaceOfFront(ctx, laceColor, 222, -260, 30)
      return
    case 'crossAndStraight':
      crossBackLaceOfFront(ctx, laceColor, 5, 0, 1)
      straightBackLaceOfFront(ctx, laceColor, 128, -270, 30)
      straightBackLaceOfFront(ctx, laceColor, 222, -260, 30)
      return
    case 'cross':
      crossBackLaceOfFront(ctx, laceColor, 5, 0, 1)
      crossBackLaceOfFront(ctx, laceColor, 128, -270, 30)
      crossBackLaceOfFront(ctx, laceColor, 225, -265, 30)
      return
    default:
      switch (position) {
        case 'outfielder':
          crossBackLaceOfFront(ctx, laceColor, 5, -15, 1)
          outfielderDefaultBackLaceForFront(ctx, laceColor, 0, 20, 0)
          return
        default:
          return
      }
  }
}

export const backLaceDrawer = (ctx: CanvasRenderingContext2D, backLaceValue: string, laceColor: string, position: Position): void => {
  switch (backLaceValue) {
    case 'straight':
      straightBackLace(ctx, laceColor)
      return
    case 'crossAndStraight':
      mixBackLace(ctx, laceColor)
      return
    case 'cross':
      crossBackLace(ctx, laceColor)
      return
    default:
      switch (position) {
        case 'outfielder':
          outfielderDefaultBackLace(ctx, laceColor)
          return
        default:
          return
      }
  }
}

export const gorillaLabelDrawerForGlove = (ctx: CanvasRenderingContext2D, state: State): void => {
  if (state.baseModel.productNumber === '001') {
    if (['overAllWappen', 'overAllEmbroidery'].includes(state.gorillaLabel?.value)) {
      gorillaLabelOverAll(ctx, 130, -20, 232, -38, 0, 1)
    }
    if (['headWappen', 'headEmbroidery'].includes(state.gorillaLabel?.value)) {
      gorillaLabelHead(ctx, 175, 50, 0, 0.9)
    }
    if (['superMatureKing', 'overAllWappen2'].includes(state.gorillaLabel?.value)) {
      gorillaLabelOverAllWithBanana(ctx, 75, -15)
      const isBomberSeries = state.series.value === 'bomber'
      isBomberSeries && gorillaEngravedOfBackBand(ctx, state.thumbOut.value, 140, 0)
    }
  }
  if (!['001', 'SKR'].includes(state.baseModel.productNumber)) {
    // 'OBK'とか他ポジション
    if (['overAllWappen', 'overAllEmbroidery'].includes(state.gorillaLabel?.value)) {
      gorillaLabelOverAll(ctx, 50, 0, 90, -2, 0, 1)
    }
    if (['headWappen', 'headEmbroidery'].includes(state.gorillaLabel?.value)) {
      gorillaLabelHead(ctx, 95, 65, 0, 0.9)
    }
    if (['superMatureKing', 'overAllWappen2'].includes(state.gorillaLabel?.value)) {
      gorillaLabelOverAllWithBanana(ctx, 0, 0)
      const existThumbEmbroidery = state.embroideries.some((e) => e.position.value === 'thumbFinger')
      const isBomberSeries = state.series?.value === 'bomber'
      !existThumbEmbroidery && isBomberSeries && gorillaEngravedOfBackThumb(ctx, state.thumbWeb.value, 0, 0)
    }
  }
  if (state.baseModel.productNumber === 'SKR') {
    if (['overAllWappen', 'overAllEmbroidery'].includes(state.gorillaLabel?.value)) {
      gorillaLabelOverAll(ctx, 50, 0, 90, -2, 0, 1)
    }
    if (['headWappen', 'headEmbroidery'].includes(state.gorillaLabel?.value)) {
      gorillaLabelHead(ctx, 95, 65, 0, 0.9)
    }
    if (['superMatureKing', 'overAllWappen2'].includes(state.gorillaLabel?.value)) {
      gorillaLabelOverAllWithBanana(ctx, 0, 0)
      const existPinkeyEmbroidery = state.embroideries.some((e) => e.position.value === 'childFinger')
      const isBomberSeries = state.series.value === 'bomber'
      !existPinkeyEmbroidery && isBomberSeries && gorillaEngravedOfBackPinkey(ctx, state.littleRing?.value, 0, 0)
    }
  }
}

export const gorillaLabelDrawerForGloveLeftThrow = (ctx: CanvasRenderingContext2D, state: State): void => {
  if (state.baseModel.productNumber === '001') {
    if (['overAllWappen', 'overAllEmbroidery'].includes(state.gorillaLabel?.value)) {
      gorillaLabelOverAll(ctx, 130, -20, 232, -38, 0, 1)
    }
    if (['headWappen', 'headEmbroidery'].includes(state.gorillaLabel?.value)) {
      gorillaLabelHead(ctx, 175, 50, 0, 0.9)
    }
    if (['superMatureKing', 'overAllWappen2'].includes(state.gorillaLabel?.value)) {
      gorillaLabelOverAllWithBanana(ctx, -50, -25)
      const isBomberSeries = state.series.value === 'bomber'
      isBomberSeries && gorillaEngravedOfBackBand(ctx, state.thumbOut.value, 200, 0)
    }
  }
  if (state.baseModel.productNumber === 'SKR') {
    if (['overAllWappen', 'overAllEmbroidery'].includes(state.gorillaLabel?.value)) {
      gorillaLabelOverAll(ctx, 50, 0, 90, -2, 0, 1)
    }
    if (['headWappen', 'headEmbroidery'].includes(state.gorillaLabel?.value)) {
      gorillaLabelHead(ctx, 95, 65, 0, 0.9)
    }
    if (['superMatureKing', 'overAllWappen2'].includes(state.gorillaLabel?.value)) {
      gorillaLabelOverAllWithBanana(ctx, 50, 0)
      const existPinkeyEmbroidery = state.embroideries.some((e) => e.position.value === 'childFinger')
      const isBomberSeries = state.series.value === 'bomber'
      !existPinkeyEmbroidery && isBomberSeries && gorillaEngravedOfBackPinkeyLeftThrow(ctx, state.littleRing?.value, 0, 0)
    }
  }
  if (!['001', 'SKR'].includes(state.baseModel.productNumber)) {
    // 'OBK'とか他ポジション
    if (['overAllWappen', 'overAllEmbroidery'].includes(state.gorillaLabel?.value)) {
      gorillaLabelOverAll(ctx, 50, 0, 90, -2, 0, 1)
    }
    if (['headWappen', 'headEmbroidery'].includes(state.gorillaLabel?.value)) {
      gorillaLabelHead(ctx, 155, 65, 0, 0.9)
    }
    if (['superMatureKing', 'overAllWappen2'].includes(state.gorillaLabel?.value)) {
      gorillaLabelOverAllWithBanana(ctx, 50, 0)
      const existThumbEmbroidery = state.embroideries.some((e) => e.position.value === 'thumbFinger')
      const isBomberSeries = state.series?.value === 'bomber'
      !existThumbEmbroidery && isBomberSeries && gorillaEngravedOfBackThumbLeftThrow(ctx, state.thumbWeb.value, 0, 0)
    }
  }
}

export const brandLabelDrawerForCatcherMitt = (ctx: CanvasRenderingContext2D, state: State, brand: Brand): void => {
  switch (brand) {
    case 'gorilla':
      if (['headEmbroidery', 'headWappen'].includes(state.gorillaLabel?.value)) {
        gorillaLabelHead(ctx, 180, 310, 0, 0.7)
      }
      if (['overAllWappen', 'overAllEmbroidery'].includes(state.gorillaLabel?.value)) {
        gorillaLabelOverAll(ctx, 50, 120, 95, 215, 0, 0.9)
      }
      if (['superMatureKing', 'overAllWappen2'].includes(state.gorillaLabel?.value)) {
        // バナナ載せ
        gorillaLabelOverAllWithBanana(ctx, -30, 50)
      }
      // if (['doubleGorilla'].some((x) => x === state.gorillaLabel?.value)) {
      //   gorillaLabelGold(ctx, -40, 55)
      // }
      break
  }
}

// メーカー捕球面の刻印
export const engravedDrawer = (ctx: CanvasRenderingContext2D, brand: Brand, catchFaceColor: string): void => {
  switch (brand) {
    case 'gorilla':
      gorillaEngravedOfCatchFace(ctx, catchFaceColor, 0, 0)
      break
  }
}
